module.exports = "data:image/gif;base64,R0lGODlhEAAQAIQWABMAExoAGiYAJi0ALTMAMxQOEjkAORsOGUAAQE0ATWAAYGYAZikpJTc2MUVEPlJSS21sYm1tY3t6b4mIe6SjlLKxof///////////////////////////////////////yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAB8ALAAAAAAQABAAAAVO4PdNTGCe5vGIXzMoSyzLSPFBxKzLSXPswEVAENwZcsVZApmMLZs8ZvMJXSQGVSsgS3AkoIpD5QArKgSSD6VASLjfbsNhwhpF7vg7XRQCADs="


//////////////////
// WEBPACK FOOTER
// ./public/pictures/markers/mapmarker_blue_default.gif
// module id = 2234
// module chunks = 0